import { Routes } from "@angular/router";
import { CompiComponent } from "./final/compi/compi.component";
import { LandingComponent } from "./final/landing/landing.component";

import { FullComponent } from "./layouts/full/full.component";
import { TracksComponent } from "./final/tracks/tracks.component";
import { IncentivesComponent } from "./final/incentives/incentives.component";
import { FameComponent } from "./final/fame/fame.component";
import { ContactComponent } from "./final/contact/contact.component";
import { SponsorsComponent } from "./final/sponsors/sponsors.component";
import { FormComponent } from "./final/form/form.component";
import { LoginComponent } from "./final/login/login.component";
import { DashbComponent } from "./dash/dashb/dashb.component";
import { IdeaComponent } from "./dash/idea/idea.component";
// import { FormtwoComponent } from './final/formtwo/formtwo.component';
import { RegComponent } from "./final/reg/reg.component";
import { GccComponent } from "./final/gcc/gcc.component";
import { TestimonialComponent } from "./final/testimonial/testimonial.component";
import { ResetComponent } from "./final/reset/reset.component";
import { ResetPassComponent } from "./final/reset-pass/reset-pass.component";
import { LoadingScreenComponent } from "./shared/loading-screen/loading-screen.component";
import { LoadingScreenService } from "./shared/loading-screen/loading-screen.service";
import { EnergyideaComponent } from "./dash/energyidea/energyidea.component";
import { SvnitsuratComponent } from "./final/svnitsurat/svnitsurat.component";
import { ThankyouComponent } from "./final/thankyou/thankyou.component";
import { LoaderComponent } from "./final/loader/loader.component";
import { WorkshopComponent } from "./final/workshop/workshop.component";
import { TimelineComponent } from "./final/timeline/timeline.component";
import { Timeline2Component } from "./final/timeline2/timeline2.component";
import { ZonalsComponent } from "./landing/zonals/zonals.component";
import { PreregComponent } from "./final/prereg/prereg.component";
import { LandComponent } from "./final/land/land.component";
import { ComingsoonComponent } from "./final/comingsoon/comingsoon.component";
import { MentorlandingComponent } from "./final/mentorlanding/mentorlanding.component";
import { MentorlistComponent } from "./final/mentorlist/mentorlist.component";
import { MentorComponent } from "./final/mentor/mentor.component";
import { ZonalloginComponent } from "./final/zonallogin/zonallogin.component";
import { MentordashComponent } from "./final/mentordash/mentordash.component";
import { MentorloginComponent } from "./final/mentorlogin/mentorlogin.component";
import { PastwinComponent } from "./final/pastwin/pastwin.component";
import { MediapresComponent } from "./final/mediapres/mediapres.component";
import { AboutusComponent } from "./final/aboutus/aboutus.component";
// import { GcctracksComponent } from "./final/gcctracks/gcctracks.component";

export const AppRoutes: Routes = [
  {
    path: "dash",
    component: FullComponent,
    children: [
      {
        path: "dash",
        redirectTo: "/dashboard",
        pathMatch: "full",
      },
      {
        path: "dash",
        loadChildren: () =>
          import("./material-component/material.module").then(
            (m) => m.MaterialComponentsModule
          ),
      },
      {
        path: "dashboard",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
    ],
  },
  // { path: '**', component: LandingComponent },
  { path: "", component: LandComponent },
  // { path: 'landing', component: LandingComponent },
  { path: "structure", component: CompiComponent },
  { path: "emp", component: MentorlandingComponent },
  { path: "empmentor", component: MentorlistComponent },
  { path: "mentor/:id", component: MentorComponent },
  { path: "mentordash", component: MentordashComponent },
  { path: "zonallogin", component: ZonalloginComponent },
  { path: "mentorlogin", component: MentorloginComponent },
  // { path: 'land', component: LandingComponent },
  // { path: "tracks", component: TracksComponent },
  { path: "workshops", component: TracksComponent },
  // { path: "tracks", component: GcctracksComponent },
  

  { path: "comingsoon", component: ComingsoonComponent },
  // { path: "incentives", component: IncentivesComponent },
  { path: "gallery", component: IncentivesComponent },

  { path: "pastwin", component: PastwinComponent },
  { path: "mediapresence", component: MediapresComponent },
  { path: "aboutus", component: AboutusComponent },

  // { path: 'fame', component: FameComponent },
  { path: "contact", component: ContactComponent },
  { path: "sponsors", component: SponsorsComponent },
  { path: "form", component: FormComponent },
  { path: "login", component: LoginComponent },
  { path: "db", component: DashbComponent },
  { path: "idea", component: IdeaComponent },
  { path: "energyidea", component: EnergyideaComponent },
  // { path: 'formtwo', component: FormtwoComponent },
  { path: "reg", component: RegComponent },
  // { path: 'eurekagcc', component: GccComponent },
  { path: "testi", component: TestimonialComponent },
  { path: "reset", component: ResetComponent },
  { path: "resetpassword", component: ResetPassComponent },
  // { path: 'resetpassword?code=/:code', component: ResetPassComponent },
  // { path: '/reset_pass/mm', component: ResetPassComponent },
  { path: "loader", component: LoadingScreenComponent },
  { path: "thankyou", component: ThankyouComponent },
  // { path: 'svnit', component: SvnitsuratComponent },
  { path: "loader", component: LoaderComponent },
  { path: "workshop", component: WorkshopComponent },
  { path: "timeline", component: TimelineComponent },
  { path: "zonals", component: ZonalsComponent },
  { path: "**", redirectTo: "/" },
  // { path: 'prereg', component: PreregComponent },
  // { path: 'timeline2', component: Timeline2Component },
];
